// extracted by mini-css-extract-plugin
module.exports = {"mainBody":"Body_mainBody__3_wHC"};